import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import * as PropTypes from 'prop-types';
import Spin from './Spin';
import { decideKeepDom } from '../../utils/keepDom';
import { consumeTheme } from '../../utils/theme';
import { PreventScrollPenetrateContainer } from '../../utils/preventScrollPenetrate';
export var LOADING_TRANSITION_DURATION = 200;
var Loading = (function (_super) {
    __extends(Loading, _super);
    function Loading() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, tip = _c.tip, visible = _c.visible, children = _c.children, embedded = _c.embedded, tipStyle = _c.tipStyle, zIndex = _c.zIndex, tipClassName = _c.tipClassName, maskClassName = _c.maskClassName, maskStyle = _c.maskStyle, spinType = _c.spinType;
            var type = children ?
                'wrap'
                : embedded ?
                    'embedded'
                    : 'fixed';
            var cls = classNames(prefixCls, className, prefixCls + "-" + type, (_a = {},
                _a[prefixCls + "-hidden"] = !visible && !embedded,
                _a));
            var maskCls = classNames(prefixCls + "-mask", prefixCls + "-mask-" + type, maskClassName, (_b = {},
                _b[prefixCls + "-mask-hidden"] = !visible,
                _b));
            var containerCls = classNames(prefixCls + "-container", prefixCls + "-container-" + type);
            var defaultSpinSize = { width: '48px', height: '48px' };
            var tipElement = tip ?
                h("div", { className: classNames(prefixCls + "-tip", tipClassName), style: tipStyle }, tip)
                : null;
            if (type === 'wrap') {
                return (h("div", { className: containerCls },
                    children,
                    h("div", { className: maskCls, style: maskStyle, "aria-hidden": !visible },
                        h("div", { className: cls, style: style },
                            h(Spin, { style: defaultSpinSize, type: spinType || 'dark' }),
                            tipElement))));
            }
            if (type === 'embedded') {
                return (h("div", { className: cls, style: __assign(__assign({}, defaultSpinSize), style) },
                    h(Spin, { type: spinType || 'dark' })));
            }
            if (!decideKeepDom.call(_this, LOADING_TRANSITION_DURATION, visible)) {
                return null;
            }
            return ReactDOM.createPortal(h(PreventScrollPenetrateContainer, { className: containerCls, style: { zIndex: zIndex }, "aria-hidden": !visible },
                h("div", { className: maskCls, style: maskStyle }),
                h("div", { className: cls, style: style },
                    h(Spin, { style: defaultSpinSize, type: spinType || 'light' }),
                    tipElement)), document.body);
        };
        return _this;
    }
    Loading.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Loading;
}(React.Component));
export default Loading;
Loading.defaultProps = {
    prefixCls: 'dui-loading',
    embedded: true
};
Loading.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    tip: PropTypes.any,
    visible: PropTypes.bool,
    tipStyle: PropTypes.object,
    tipClassName: PropTypes.string,
    embedded: PropTypes.bool,
    zIndex: PropTypes.number,
    maskClassName: PropTypes.string,
    maskStyle: PropTypes.object,
    spinType: PropTypes.oneOf(['light', 'dark', 'primary'])
};
